/**
 * Editor View should be the default view, when there is no other view to show
 * this view might handle more than one creative type 
 * so this might need to be breakdown if it gets to complex
 */
import React, { useState, useRef, useEffect } from "react";
import CreativeComponent from "components/atoms/CreativeComponent";
import CreativeSizeDisplay from "components/atoms/CreativeSizeDisplay"
import { useAppState, useAppDispatch } from "context";
import { useMobileOrientation, isMobileOnly } from "react-device-detect";
import { CreativeType } from "types/creative";
import { PLAYBACK_TYPE, VIDEO_CONTROLS_HEIGHT } from 'services/constants'
import { getCreativeDimensions, getPlaybackName } from 'services/utils';
import { setCreativeViewSize } from 'context/actions';


import "./EditorView.scss";

const EditorView = () => {
  const dispatch = useAppDispatch();
  const { isLandscape } = useMobileOrientation();
  const container = useRef<HTMLDivElement>(null);
  const {
    creative = {} as CreativeType,
    sizeViewList,
    activeCreativeView
  } = useAppState();

  const {media_type, playback_id } = creative
  const { share } = activeCreativeView
  const [videoControls, setVideoControls ] = useState(media_type === 1 && (playback_id === PLAYBACK_TYPE.shop || playback_id === PLAYBACK_TYPE.maxo3  || playback_id === PLAYBACK_TYPE.lite))
  const [switchToPortrait, setSwitchToPortrait] = useState(false)
  useEffect(() => {
  
    // do not modify size if playback is tiktok or social
    if(isMobileOnly) {
      if(playback_id !== PLAYBACK_TYPE.social) {
        const { current } = container
        if(current) {
          const { width, height } = current.getBoundingClientRect()
          let size = {}
          if(isLandscape) {
            const overrideHeight = videoControls ? height - VIDEO_CONTROLS_HEIGHT : height
            size = getCreativeDimensions(creative, null, overrideHeight);
            dispatch(setCreativeViewSize(size));
          } else {
            if(playback_id === PLAYBACK_TYPE.tiktok) {
              size = getCreativeDimensions(creative, null, height);
            } else {
              size = getCreativeDimensions(creative, width, null);
            }
            dispatch(setCreativeViewSize(size));
          }
        }
      } else {
        setSwitchToPortrait(isLandscape)
      }
    }
   
    }, [isLandscape])

  return (
    <div className={`default-container ${isLandscape ? 'landscape' : ''} ${isMobileOnly ? 'mobile' : ''}`} ref={container}>
        { !!(!isMobileOnly && !share && sizeViewList?.length) && <CreativeSizeDisplay/>}
        <CreativeComponent videoControls={videoControls} className={`${isMobileOnly ? 'mobile-center' : ''}`} />
        {/* TODO: consider making a component for portrait to display where needed */}
        {switchToPortrait && <div className="switch-to-portrait">Please switch to portrait mode</div>}
    </div>
  );
};

export default EditorView;
